const slugify = (text) => {
  const placeholder = String(text);
  if (placeholder === "") {
    return "";
  }
  const slug = placeholder.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "-").replace(/-{2,}/g, "-").replace(/^-|-$/g, "");
  return slug !== "" ? slug : "-";
};
const addQueryParams = (url, params) => {
  const urlObj = new URL(url);
  Object.keys(params).forEach((key) => {
    if (params[key] != null && !url.includes(`${key}=`)) {
      urlObj.searchParams.append(key, params[key]);
    }
  });
  return urlObj.toString();
};
export {
  addQueryParams as a,
  slugify as s
};
//# sourceMappingURL=addQueryParams-CbXuSGTY.js.map
